<h2 i18n="birthdays header@@birthdays-header" class="widget-header h4 d-none d-lg-block">Birthday calendar</h2>

<ng-container *ngIf="(birthdayPersonsToday$ | async) as birthdayPersonsToday; else loading">
    <div *ngIf="birthdayPersonsToday.length > 0" class="mt-2 compact-birthday-component-container">
        <ul class="row list-unstyled">
            <li *ngFor="let birthdayPersonToday of birthdayPersonsToday" class="compact-birthday-content">
                <div class="site-container">
                    <div class="site-initials">
                        <a href="{{ birthdayPersonToday.Path }}" title="{{ birthdayPersonToday.PreferredName }}">
                            <ng-container *ngIf="birthdayPersonToday.photoUrl$ | async as src;else tempImg">
                                <div class="rounded-circle birthday-user-img"
                                    [ngStyle]="{'background-image': 'url(' + src + ')'}"
                                    title="{{ birthdayPersonToday.PreferredName }}"></div>
                            </ng-container>
                            <ng-template #tempImg>
                                <div class="letters accent-1-bg-color rounded-circle position-relative"
                                    title="{{ birthdayPersonToday.PreferredName }}">
                                    <h3 class="mb-0 letters-text small">{{
                                        getPreferredNameLetters(birthdayPersonToday.PreferredName) }}</h3>
                                </div>
                            </ng-template>
                        </a>
                    </div>
                    <h3 class="site-title text-break h6 mb-0">
                        <a href="{{ birthdayPersonToday.Path }}" title="{{ birthdayPersonToday.PreferredName }}"
                            class="link-text-color">
                            <span class="extra-bold">{{ birthdayPersonToday.PreferredName }}</span>
                        </a>
                    </h3>
                    <span class="site-title small birthday-department text-break d-block">{{ birthdayPersonToday.Department }}</span>
                    
                    <span class="site-title small d-block">
                        <a [attr.href]="('https://teams.microsoft.com/l/chat/0/0?users=' + birthdayPersonToday.WorkEmail) | safe: 'url'" *ngIf="useTeamsCongratulations">
                            <i class="mr-1 ms-Icon ms-Icon--TeamsLogo align-bottom" aria-hidden="true"></i>
                            <span i18n="@@congratulate">Congratulate on Teams</span>
                        </a>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</ng-container>

<div *ngIf="fetchedAmount > 4" class="row justify-content-start">
    <div class="col-auto pr-0 pl-0">
      <button mat-button class="events-show-more-btn" (click)="clickShowPrevious()" [disabled]="numberOfShowMoreClicks === 0">
        <span class="small bolder" i18n="@@show-previous">Previous</span>
      </button>
    </div>
    <div class="pt-2">
      <span class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 0 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
      <span *ngIf="fetchedAmount && fetchedAmount > 4" class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 1 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
      <span *ngIf="fetchedAmount && fetchedAmount > 8" class="dot" [ngClass]="numberOfShowMoreClicks === 2 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    </div>
     <div class="col-auto pr-0 pl-0">
      <button mat-button class="events-show-more-btn" (click)="clickShowNext()" [disabled]="numberOfShowMoreClicks === 2 || numberOfShowMoreClicks === maxNumberOfShowMoreClicks">
        <span class="small bolder" i18n="@@show-next">Next</span>
      </button>
    </div>
   </div>

<ng-template #loading>
  <div *ngIf="errorSubject$ | async as err; else innerLoading">
    <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
  </div>
  <ng-template #innerLoading>
    <div>
      <app-widget-placeholder></app-widget-placeholder>
    </div>
  </ng-template>
</ng-template>

